"use client";

import React from "react";

interface AuthPageWrapperProps {
  children: React.ReactNode;
}

export const AuthPageWrapper: React.FC<AuthPageWrapperProps> = ({
  children,
}) => {
  return <>{children}</>;
};
